<div mat-dialog-title [class]="'dialog-' + data.type" class="dialogContainer">
    <label class="labelTitle">{{data.title | translate}}</label>
    <button type="button" class="btn-close btn-close-white shadow-none p-0" aria-label="Close dialog" (click)="onNoClick()"></button>
</div>
<mat-dialog-content class="dialogContent">
    <div class="dialogBody" [class.with-icon]="data.showIcon">
        <div class="iconSection" *ngIf="data.showIcon">
            <mat-icon class="dialogIcon">{{data.type}}</mat-icon>
        </div>
        <div class="dialogMessage">{{data.message | translate}}</div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialogActionsBtns">
    <button mat-raised-button color="primary" (click)="onYesClick()">{{'YES' | translate}}</button>
    <button mat-raised-button color="warn" (click)="onNoClick()">{{'NO' | translate}}</button>
</mat-dialog-actions>
